import { useState } from 'react';

import { IconLink } from '@iwoca/icons';
import { useParams } from 'react-router-dom';

import styles from './ShareLinkOpenBanking.module.css';
import { useGetOpenBankingProviders } from '../../api/openBankingShareableLinkApi/useGetOpenBankingProviders';
import { useGetOpenBankingShareableLink } from '../../api/openBankingShareableLinkApi/useQueryOpenShareableLink';
import { Button } from '../Button/Button';
import { BankSelectionModal } from '../TradingHistory/OpenBanking/BankSelectionModal/BankSelectionModal';
import { TrueLayerDocumentRequirementContentUK } from '../TradingHistory/OpenBanking/LinkOpenBankingDocumentRequirementContent/TrueLayerDocumentRequirementContentUK';

export const ShareLinkOpenBanking = () => {
  const { token } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { openBankingLink, isLoading: isShareableLinkLoading } =
    useGetOpenBankingShareableLink({ token });
  const stateKey = openBankingLink?.state_key;

  const { bankList, isLoading: isProvidersLoading } =
    useGetOpenBankingProviders({
      stateKey,
      token,
    });

  const isBankListReady =
    !isShareableLinkLoading && !isProvidersLoading && stateKey;

  const businessName = openBankingLink?.business_name;

  const handleLinkBankAccount = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.title}>
          {businessName} needs your help to finish their loan application.
        </h1>
        <h2 className={styles.subTitle}>
          You have been requested to link their business bank account via our
          secure platform.
        </h2>
      </div>

      <p className={styles.description}>
        <strong>
          Link {businessName}’s business bank account using Open Banking
        </strong>
      </p>
      <div className={styles.truelayerRequirement}>
        <TrueLayerDocumentRequirementContentUK />
      </div>

      <div>
        <Button
          className={styles.button}
          onClick={handleLinkBankAccount}
          disabled={!isBankListReady}
        >
          Link bank account <IconLink />
        </Button>
      </div>

      <BankSelectionModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        bankList={bankList}
        shouldSkipPermissionView={false}
        stateKey={stateKey || ''}
        ableToShareLink={false}
      />
    </div>
  );
};
